import { jsx, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import { ReactComponent } from '@sketch/icons/cross-16';
import { SKETCH_WEBSITE } from '@sketch/env-config';
import '../../routes/index.js';
import { Flex, Caption, IconButton } from '@sketch/components';
import { getIsForInAppPresentation } from '../../routes/useSketchSource/useSketchSource.js';

const Container = styled(Flex) `
  border-radius: 2rem; /* stylelint-disable-line scales/radii */
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  background-clip: padding-box;
  padding: 8px 16px 8px 1.4rem; /* stylelint-disable-line scales/space */
  justify-content: center;
`;
const CookieCaption = styled(Caption) `
  margin: 0;
`;
const CookieLink = styled.a `
  font-weight: 400;
`;
const CookieBanner = ({ onClickClose }) => {
    const isForInAppPresentation = getIsForInAppPresentation();
    const target = isForInAppPresentation ? '_self' : '_blank';
    return (jsx(Container, { children: jsxs(Flex, Object.assign({ justifyContent: "center" }, { children: [jsxs(CookieCaption, Object.assign({ color: "#000" }, { children: ["By using Sketch, you agree to our", ' ', jsx(CookieLink, Object.assign({ href: `${SKETCH_WEBSITE}/tos`, target: target, rel: "noopener noreferrer" }, { children: "Terms of Service" })), "."] })), jsx(IconButton, { icon: ReactComponent, onClick: onClickClose, style: { marginLeft: '1rem' } })] })) }));
};

export { CookieBanner as default };
